<template>
  <div>
    <input
      ref="fileInput"
      type="file"
      :multiple="multiple"
      :accept="accept"
      class="hidden"
      @change="handleChange"
    />
    <slot
      :pickFile="pickFile"
      :uploading="uploading"
      :progress="progress"
      :displayText="displayText"
    >
      <el-button @click="pickFile" icon="el-icon-upload">
        {{ displayText }}
      </el-button>
    </slot>
  </div>
</template>

<script>
export default {
  name: "UploadFileButton",
  emits: ["uploaded", "error"],
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    accept: {
      type: String,
      default: ".txt,.md,.csv,.json,.doc,.docx,.pdf,application/json,text/plain,text/markdown,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    },
    uploadFn: {
      type: Function,
      required: true, // 由父组件传入上传实现
    },
    limitSize: {
      type: Number,
      default: 10 * 1024 * 1024, // 默认限制为10MB
    },
  },
  data() {
    return {
      uploading: false,
      progress: 0, // 0~100
    };
  },
  computed: {
    displayText() {
      return this.uploading ? `Uploading... ${this.progress}%` : "Add Files";
    },
  },
  methods: {
    pickFile() {
      this.$refs.fileInput.click();
    },
    async handleChange(e) {
      const me = this;
      const files = Array.from(e.target.files);
      if (!files.length) return;
      const MAX_SIZE = me.limitSize;
      if (!files.length) return;
      // 检查文件大小
      const oversized = files.find((file) => file.size > MAX_SIZE);
      if (oversized) {
        this.$message.error(`File "${oversized.name}" exceeds ${MAX_SIZE / 1024 / 1024}MB limit.`);
        this.uploading = false;
        e.target.value = "";
        return;
      }
      this.uploading = true;
      this.progress = 0;
      try {
        const results = [];
        for (const file of files) {
          // 支持进度回调
          const res = await this.uploadFn(file, (evt) => {
            const percent = Math.round((evt.loaded / evt.total) * 100);
            this.progress = percent;
          });
          results.push(res);
        }
        this.progress = 100;
        this.$emit("uploaded", this.multiple ? results : results[0]);
      } catch (err) {
        this.$emit("error", err);
      } finally {
        this.uploading = false;
        setTimeout(() => {
          this.progress = 0;
        }, 500); // 上传结束后清零
        e.target.value = "";
      }
    },
  },
};
</script>
